import { Component, OnInit } from '@angular/core';
import { BreadcrumbService, ApplicationService } from '@picard/services-lib';
import { Title } from '@angular/platform-browser';
import { PreAuthenticationResponse, UsersModel, LogonResponse } from '@picard/models-lib';
import { StorageConstants } from '@picard/shared-lib';
import { PlatformService } from '@picard/services-lib';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-merge-account',
  templateUrl: './merge-account.component.html',
  styleUrls: ['./merge-account.component.css']
})
export class MergeAccountComponent implements OnInit {
  //#region Properties
  preAuthenticationResponse: PreAuthenticationResponse;
  logonResponse: LogonResponse;
  @BlockUI() blockUI: NgBlockUI;
  searchValue: string;
  usersModelCollection: UsersModel[];
  cols: any[];
  mergedUsersModel: UsersModel;
  likeSearch: boolean;
  docTheme = document.getElementById('theme-css');
  docLayout = document.getElementById('layout-css');
  //#endregion Properties

  //#region Constructor
  constructor(private _breadcrumbService: BreadcrumbService, private _title: Title, private _platformService: PlatformService, private _applicationService: ApplicationService) {
    this._breadcrumbService.setItems([{ label: 'Merge Account', routerLink: '/merge-account' }]);

    if (this.docTheme) {
      this.docTheme.setAttribute('href', this._applicationService.preAuthenticationResponse.programmeAssetsModel.theme);
    }
    if (this.docLayout) {
      this.docLayout.setAttribute('href', this._applicationService.preAuthenticationResponse.programmeAssetsModel.layout);
    }
  }
  //#endregion Constructor

  //#region Functions
  ngOnInit() {
    this.preAuthenticationResponse = JSON.parse(sessionStorage.getItem(StorageConstants.preAuth));
    this.logonResponse = JSON.parse(sessionStorage.getItem(StorageConstants.loginDetails));
    this._title.setTitle(`${this.preAuthenticationResponse.description} - Merge Account`);
  }
  async onSearch() {
    if (!this.searchValue) {
      Swal({ type: 'error', title: 'Search value required', showConfirmButton: false, timer: 1500 });
    } else {
      this.blockUI.start(`Searching for users to match to: ${this.searchValue}`);
      this.usersModelCollection = await this._platformService.GetUsersModelByMobileNumberAsync((this.likeSearch) ? `%${this.searchValue}%` : this.searchValue, this.preAuthenticationResponse.programId);
      if (this.usersModelCollection) {
        this.cols = [
          { field: 'userId', header: 'User Id' },
          { field: 'mobileNumber', header: 'Mobile Number' },
          { field: 'createdDateUtc', header: 'Date Created' },
          { field: 'externalId', header: 'External Id' }];
      }
    }
    this.blockUI.stop();
  }
  async onMerge(rowData: UsersModel) {
    //console.log(JSON.stringify(rowData));
    this.blockUI.start(`Merging accounts, this can take some time.`);
    this.mergedUsersModel = await this._platformService.MergeAccountAsync(rowData, this.logonResponse.usersModel.userId);
    this.blockUI.stop();
  }
  //#endregion Functions
}
